import _ from 'lodash'
import REF_DATA from '../constants/REF_DATA.json'
import NAMESPACE_CONFIGS from '../constants/NAMESPACE_CONFIGS.json'
import DEFAULT_ITEMS_MAP from '../constants/DEFAULT_ITEMS_MAP.json'
import type {Namespace, NamespaceConfig, RefInfo, SchemaService} from '@wix/document-services-types'

const getNamespaceConfig = (namespace: string): NamespaceConfig =>
    (NAMESPACE_CONFIGS as Record<string, NamespaceConfig>)[namespace]

const extractReferenceFieldsInfo = (namespace: string, dataTypeName: string, data?: any): readonly RefInfo[] => {
    const refs = _.get(REF_DATA, [namespace, dataTypeName])
    if (data) {
        return _.filter(refs, (refInfo: RefInfo) => _.has(data, refInfo.path))
    }
    return _.values(refs)
}

const createItemAccordingToSchema = (schemaName: string, namespace: Namespace) =>
    (DEFAULT_ITEMS_MAP as Record<string, Record<string, any>>)[namespace]?.[schemaName]

export const schemaService: SchemaService = {
    getNamespaceConfig,
    extractReferenceFieldsInfo,
    createItemAccordingToSchema
} as unknown as SchemaService
